import React from 'react'
import './Style/Header.css'
import Logo from '../Image/logo.png'
function Header({info,product,date,customer}) {
  return <div className='invoice-header px-10 pt-5 mb-4'>


    <div className='grid grid-cols-2'>


        <div className='md:col-span-1 col-span-2 flex items-center z-20'>
             <img src={Logo} alt='' className='w-36'></img>
             <div>
                 <h1 className='text-3xl tracking-widest font-bold '> Brand Name </h1>
                 <p className='text-sm tracking-wide text-color-text'> TAGLINE SPACE HERE </p>
             </div>
        </div>

        <div className='md:col-span-1 col-span-2 w-full flex items-center justify-center px-6 flex-col'>
            <h1 className='text-main-color font-bold text-7xl mb-2 z-20 relative'> INVOICE </h1>
            <div className='w-10/12 flex justify-between items-center'>
                <p className='font-bold text-lg'> Invoice # </p>
                <p> {product.invoiceNumber} </p>
            </div>
            <div className='w-10/12 flex justify-between items-center mt-3'>
                <p className='font-bold text-lg'> Date </p>
                <p> {date} </p>
            </div>
        </div>
    </div>
  </div>
}

export default Header